import React from 'react'
import ReactDOM from 'react-dom'
import styles from './CueList.scss'
import { Distance } from 'common/units'
import cx from 'classnames'
import { FormattedMessage as T } from 'react-intl'

class CueIcon extends React.PureComponent {
  render () {
    const { selected, confirmed, deleted } = this.props

    if (deleted && !selected) {
      return (<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M128 405.43c0 23.416 19.198 42.57 42.667 42.57h170.667C364.802 448 384 428.846 384 405.43V160H128v245.43zM416 96h-80l-26.785-32h-106.43L176 96H96v32h320V96z' /></svg>)
    }

    const confirmedIcon = (<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm-42.7 318.9L106.7 260.3l29.9-29.9 76.8 76.8 162.1-162.1 29.9 29.9-192.1 191.9z' /></svg>)

    return (
      confirmed && !selected ? confirmedIcon
        : <svg width='25px' height='25px' viewBox='0 0 25 25' version='1.1' xmlns='http://www.w3.org/2000/svg'>
          <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='cueRadioButton'>
              <circle id='Oval' stroke={selected ? '#FA6400' : '#E0E0E0'} strokeWidth='2' cx='12.5' cy='12.5' r='11.5' />
              {selected && <circle id='Oval-2' fill='#FA6400' cx='12.5' cy='12.5' r='5.5' />}
            </g>
          </g>
        </svg>
    )
  }
}

class Cue extends React.PureComponent {
  componentDidUpdate () {
    const { cue, currentCue, ensureCueIsInView } = this.props
    if (cue.distance === (currentCue && currentCue.distance)) {
      ensureCueIsInView(cue, ReactDOM.findDOMNode(this))
    }
  }

  render () {
    const { cue, i, currentCue, cuePicked, cues } = this.props

    const isSelected = cue.distance === (currentCue && currentCue.distance)

    const fromStart = cue.distance
    const fromPrevious = (i - 1 >= 0) ? cue.distance - cues.get(i - 1).distance : 0

    return (
      <div className={cx(styles.Cue, cue.distance === (currentCue && currentCue.distance) && styles.selected, cue.deleted && styles.deleted)} onClick={() => cuePicked(cue)}>
        <div className={cx(styles.iconContainer, cue.confirmed && styles.confirmed)}>
          <CueIcon selected={isSelected} confirmed={cue.confirmed} deleted={cue.deleted} />
        </div>
        <div className={styles.cueInfo}>
          <div className={cx(cue.deleted && styles.strikethrough)}>
            {cue.type} - {cue.notes}
          </div>
          <div className={styles.distances}>
            <div><Distance value={fromStart} bigUnits short /></div>
            <div><Distance value={fromPrevious} short /></div>
          </div>
        </div>
      </div>
    )
  }
}

export class CueList extends React.PureComponent {
  ensureCueIsInView = (cue, cueEl) => {
    const el = ReactDOM.findDOMNode(this)

    const bottomOfCueRow = (cueEl.offsetTop - el.scrollTop) + cueEl.clientHeight // Distance from the top of the list container to the bottom of the cue
    const bottomOfCueListViewport = el.offsetTop + el.offsetHeight // Bottom of the cue list container
    if (bottomOfCueRow > bottomOfCueListViewport) {
      el.scrollTop = el.scrollTop + (el.clientHeight * 0.8)
    }

    const topOfCueRow = cueEl.offsetTop - el.scrollTop
    const topOfCueListViewport = el.offsetTop
    if (topOfCueRow < topOfCueListViewport) {
      el.scrollTop = el.scrollTop - (el.clientHeight * 0.8)
    }
  }

  render () {
    const { currentCue, cuePicked, cues } = this.props

    const items = this.props.cues.map((cue, i) => (
      <Cue cue={cue} i={i} cuePicked={cuePicked} currentCue={currentCue} key={i} cues={cues} ensureCueIsInView={this.ensureCueIsInView} />
    ))

    return (
      <div className={styles.CueList}>
        {items}
        <div className={styles.Cue}>
          <T id='CueList.endOfCuesheet' defaultMessage='End of cuesheet.' />
        </div>
      </div>
    )
  }
}
